<script>
    import { PolarArea } from "svelte-chartjs";
    import { polarData, polarOptions, applyChartDefaults } from "./chartTheme";

    applyChartDefaults();

    export let data = {
        labels: ["Malo", "Muy Malo", "Regular", "Bueno", "Muy bueno"],
        datasets: [{ data: [0, 0, 0, 0, 0], label: "Pregunta" }],
    };

    $: styled = polarData(data);
</script>

<div class="chart-box">
    <PolarArea data={styled} options={polarOptions} />
</div>

<style>
    .chart-box {
        position: relative;
        height: 260px;
    }
</style>
